var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#761078"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8243_37801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6227 32.9012C23.6227 34.1745 22.5833 35.2126 21.3114 35.2126C20.0395 35.2126 19 34.1745 19 32.9026C19 31.6307 20.0395 30.5913 21.31 30.5913H23.6227V32.9012ZM24.786 32.9012C24.786 31.6307 25.8255 30.5913 27.0974 30.5913C28.3693 30.5913 29.4088 31.6307 29.4088 32.9012V38.69C29.4088 39.9605 28.3693 41 27.0988 41C26.4862 40.9989 25.899 40.7553 25.4656 40.3224C25.0322 39.8895 24.7878 39.3026 24.786 38.69V32.9012ZM27.0988 23.6227C25.8255 23.6227 24.786 22.5833 24.786 21.3114C24.786 20.0395 25.8255 19 27.0988 19C28.372 19 29.4088 20.0395 29.4088 21.31V23.6227H27.0988ZM27.0988 24.786C28.3693 24.786 29.4088 25.8255 29.4088 27.0974C29.4088 28.3693 28.3693 29.4088 27.0988 29.4088H21.31C20.0409 29.4088 19 28.3693 19 27.0988C19 25.8255 20.0395 24.786 21.31 24.786H27.0988ZM36.3786 27.0988C36.3786 25.8255 37.4167 24.786 38.6886 24.786C39.9605 24.786 41 25.8255 41 27.0974C41 28.3693 39.9605 29.4088 38.69 29.4088H36.3786V27.0988ZM35.2126 27.0988C35.2126 28.3693 34.1745 29.4088 32.9026 29.4088C32.2903 29.4073 31.7034 29.1635 31.2703 28.7306C30.8372 28.2978 30.5931 27.7111 30.5913 27.0988V21.31C30.5913 20.0409 31.6307 19 32.9012 19C34.1745 19 35.2126 20.0395 35.2126 21.31V27.0988ZM32.9012 36.3772C34.1745 36.3772 35.214 37.4167 35.214 38.6886C35.214 39.9605 34.1745 41 32.9012 41C31.628 41 30.5899 39.9605 30.5899 38.69V36.3772H32.8999H32.9012ZM32.9012 35.2126C31.6307 35.2126 30.5913 34.1745 30.5913 32.9026C30.5913 31.6307 31.6307 30.5913 32.9012 30.5913H38.69C39.9605 30.5913 41 31.6307 41 32.9012C41 34.1745 39.9605 35.2126 38.69 35.2126H32.9012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8243_37801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.7b90b19d265f00b8fe0076cbd1e0bb43.svg";
export { ForwardRef as ReactComponent };